// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*\n * PageInfo css File\n*/\n.history .history-btn {\n  display: none;\n}", "",{"version":3,"sources":["webpack://src/Components/History/history.scss"],"names":[],"mappings":"AAAA;;CAAA;AAIA;EACI,aAAA;AAAJ","sourcesContent":["/*\n * PageInfo css File\n*/\n\n.history .history-btn {\n    display: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
